// client/src/api/EntitlementApi.ts
import { axiosInstance } from "../helpers/request";
import type { StreamEntitlement } from "../types/billing";

class EntitlementApi {
  getEntitlement(streamId: string) {
    return axiosInstance.get<StreamEntitlement>(`/streams/${streamId}/entitlement`);
  }
}

const entitlementApiInstance = new EntitlementApi();
export default entitlementApiInstance;
